import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';

import { usePanelContentsSubscribe } from '../../components/Panels/shared/CollapsiblePanel/CollapsiblePanel.hook';
import {
  Datepicker,
  DatepickerProps,
} from '../../../ToolkitV2/Inputs/Datepicker/Datepicker';

type FinanceDatepickerFieldProps = Omit<
  DatepickerProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceDatepickerField = forwardRef<
  HTMLInputElement,
  FinanceDatepickerFieldProps
>((props, ref) => {
  const { invalid, value, isOptional = false, ...rest } = props;
  usePanelContentsSubscribe({
    name: props.name,
    value,
    invalid,
    isOptional,
  });
  return (
    <Datepicker
      {...rest}
      hasError={invalid}
      errorMessage={props.error?.message}
      ref={ref}
      value={value}
    />
  );
});

FinanceDatepickerField.displayName = 'FinanceTextField';
